import {
  ecomWidgets,
  bestSellingProducts,
  topSellers,
  recentOrders,
  topCategories,
  allRevenueData, monthRevenueData, halfYearRevenueData, yearRevenueData
} from "./dashboardEcommerce";

import {
  kEcomWidgets,
  kBestSellingProducts,
  kTopSellers,
  kRecentOrders,
  kTopCategories,
  kAllRevenueData, kMonthRevenueData, kHalfYearRevenueData, kYearRevenueData
} from "./Kdashboard";

import {
    kTodayAudiencesCountryData,
    kLastWeekAudiencesCountryData,
    kLastMonthAudiencesCountryData,
    kCurrentYearAudiencesCountryData
} from "./Kdashboard";

export {
  ecomWidgets,
  bestSellingProducts,
  topSellers,
  recentOrders,
  topCategories,
  kEcomWidgets,
  kBestSellingProducts,
  kTopSellers,
  kRecentOrders,
  kTopCategories,
  kAllRevenueData,
  kMonthRevenueData,
  kHalfYearRevenueData,
  kYearRevenueData,
  kTodayAudiencesCountryData,
  kLastWeekAudiencesCountryData,
  kLastMonthAudiencesCountryData,
  kCurrentYearAudiencesCountryData
};
